<div [style.height]="height + 'px'">
    <fusioncharts *ngIf="!hideChart" width="100%" [height]="height" [chartConfig]=chartConfig [dataSource]=dataSource>
    </fusioncharts>
</div>
